/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import {
  getAdjustmentReasonCodeResultGrid,
  getAdjustmentByReasonCodeExportAll,
  setAdjustmentByReasonCodeExportAll,
  setOpenModal,
  setPaginationIndex,
} from '../Store/actions';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { getRequiredColumn } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { exportAllPDF } from './ExportAll';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';



export default function DispAdjustmentReasonCode() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);
  const [columnApi, setColumnApi] = React.useState(null);
  const {
    isLoading,
    dispalyObj: {
      rebateProgrameName,
      rebateProgramValue,
      fromDateValue,
      toDateValue,
      searchResult,
      adjustmentSelected,
      selectedPlanType,
      rebateProgramList,
      countValue,
    },
    exportAllData,
  } = useSelector((state) => state?.sharedState?.AdjustmentReasonCodeReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [error, setError] = useState([]);
  const dateRange = {
    fromDate: fromDateValue,
    toDate: toDateValue === '' ? fromDateValue : toDateValue,
  };
  let { fromDate } = dateRange;
  let { toDate } = dateRange;
  if (fromDate?.includes('Q')) {
    fromDate = convertStringDate(quarterToDate(fromDate, 'fromDate'));
  }
  if (toDate?.includes('Q')) {
    toDate = convertStringDate(quarterToDate(toDate, 'toDate'));
  }
  const [count, setCount] = React.useState(countValue);
  const paginationArray = [...Array(adjustmentSelected.length).keys()];
  const [mfgOrder, setMfgOrder] = React.useState('asc');
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };
  const [tableCount, setTableCount] = useState(0);

  // TO handle any changes in the pagination text field
  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      await Promise.resolve();
      // setTimeout(() => {
      (value < 1)
        ? dispatch(setPaginationIndex(1))
        : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  const [drugActivityTypeSelected, setDrugActivityTypeSelecte] = React.useState(
    []
  );

  React.useEffect(() => {
    const drugActivityTypeSelected = [];
    if (adjustmentSelected[count - 1]?.codeValue === 'R') {
      drugActivityTypeSelected.push('URAC', 'URCA', 'URAL');
    }
    if (adjustmentSelected[count - 1]?.codeValue === 'W') {
      drugActivityTypeSelected.push('WOFF', 'DBAL', 'FRGV');
    }
    if (adjustmentSelected[count - 1]?.codeValue === 'I') {
      drugActivityTypeSelected.push('IOAR', 'IDBL');
    }
    if (adjustmentSelected[count - 1]?.codeValue === 'X') {
      drugActivityTypeSelected.push('ICLC', 'IDBU');
    }
    if (adjustmentSelected[count - 1]?.codeValue === 'U') {
      drugActivityTypeSelected.push(
        'UACD',
        'UACM',
        'UAAR',
        'UCCN',
        'UOCR',
        'UOMR'
      );
    }
    if (adjustmentSelected[count - 1]?.codeValue === 'T') {
      drugActivityTypeSelected.push('DBUP');
    }
    setDrugActivityTypeSelecte(drugActivityTypeSelected);
    if (adjustmentSelected.length > 1) {
      dispatch(
        getAdjustmentReasonCodeResultGrid(
          {
            rebateProgramCd: rebateProgramValue,
            beginDate: fromDate,
            endDate: toDate,
            drugActivityTypeCd: drugActivityTypeSelected,
            mfgTypeCd:
              selectedPlanType === 'FD' || selectedPlanType === 'ST'
                ? 'G'
                : 'C',
          },
          true
        )
      );
    }
  }, [adjustmentSelected[count - 1]?.codeValue]);
  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    dispatch(setAdjustmentByReasonCodeExportAll([], 'noData'));
    setExportAllClicked(true);
    dispatch(
      getAdjustmentByReasonCodeExportAll({
        rebateProgramCd: rebateProgramValue,
        beginDate: fromDate,
        endDate: toDate,
        drugActivityTypeCd: adjustmentSelected,
        mfgTypeCd:
          selectedPlanType === 'FD' || selectedPlanType === 'ST' ? 'G' : 'C',
      })
    );
  };

  const sortedKey = (arr, orderBy) => {
    const multiplier = orderBy === 'desc' ? -1 : 1;
    arr.sort(
      (a, b) =>
        multiplier *
        (a.toLowerCase() > b.toLowerCase()
          ? 1
          : a.toLowerCase() < b.toLowerCase()
          ? -1
          : 0)
    );
    return arr;
  };
  const groupByData = (data, key, orderBy) => {
    const tempObj = {};
    for (let i = 0; i < data.length; i += 1) {
      if (tempObj[data[i][key]]) {
        tempObj[data[i][key]].data.push(data[i]);
        tempObj[data[i][key]].changeAmt =
          tempObj[data[i][key]].changeAmt + data[i].changeAmt;

        if (tempObj[data[i][key]][[data[i].drugActivityTypeCd]]) {
          tempObj[data[i][key]][[data[i].drugActivityTypeCd]] =
            tempObj[data[i][key]][[data[i].drugActivityTypeCd]] +
            data[i].changeAmt;
        } else {
          tempObj[data[i][key]][[data[i].drugActivityTypeCd]] =
            data[i].changeAmt;
        }
      } else {
        tempObj[data[i][key]] = {
          data: [data[i]],
          changeAmt: data[i].changeAmt,
        };
        if (tempObj[data[i][key]][[data[i].drugActivityTypeCd]]) {
          tempObj[data[i][key]][[data[i].drugActivityTypeCd]] =
            tempObj[data[i][key]][[data[i].drugActivityTypeCd]] +
            data[i].changeAmt;
        } else {
          tempObj[data[i][key]][[data[i].drugActivityTypeCd]] =
            data[i].changeAmt;
        }
      }
    }

    let gropusKey = Object.keys(tempObj);
    gropusKey = sortedKey(gropusKey, orderBy);
    const sortedObj = gropusKey.reduce((obj, key) => {
      obj[key] = tempObj[key];
      return obj;
    }, {});
    return sortedObj;
  };

  const getFlatArrWithTotal = (groupedData, keyTextForTotal, totalText) => {
    let flatGroupDataWithTotal = [];
    for (const key in groupedData) {
      const updatedData = groupedData[key].data.map((item, i) => {
        return {
          ...item,
          mfgName: i !== 0 ? '' : item.mfgName,
        };
      });
      delete groupedData[key].data;
      flatGroupDataWithTotal = [
        ...flatGroupDataWithTotal,
        ...updatedData,
        { ...groupedData[key], [keyTextForTotal]: totalText },
      ];
    }
    // , mfgName: key
    return flatGroupDataWithTotal;
  };

  const getDataForTable = (data, groupByKey, orderBy) => {
    const groupedData = groupByData(data, groupByKey, orderBy);
    let updatedSearchResult = getFlatArrWithTotal(
      groupedData,
      'targetQtr',
      'Total'
    );
    updatedSearchResult = updatedSearchResult?.map((item) => {
      if (item.drugActivityTypeCd === 'URAC') {
        return {
          ...item,
          URAC: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'URCA') {
        return {
          ...item,
          URCA: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'URAL') {
        return {
          ...item,
          URAL: item.changeAmt,
          total: item.changeAmt,
        };
      }

      if (item.drugActivityTypeCd === 'WOFF') {
        return {
          ...item,
          WOFF: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'DBAL') {
        return {
          ...item,
          DBAL: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'FRGV') {
        return {
          ...item,
          FRGV: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'IOAR') {
        return {
          ...item,
          IOAR: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'IDBL') {
        return {
          ...item,
          IDBL: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'ICLC') {
        return {
          ...item,
          ICLC: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'IDBU') {
        return {
          ...item,
          IDBU: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UACD') {
        return {
          ...item,
          UACD: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UACM') {
        return {
          ...item,
          UACM: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UAAR') {
        return {
          ...item,
          UAAR: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UCCN') {
        return {
          ...item,
          UCCN: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UOCR') {
        return {
          ...item,
          UOCR: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'UOMR') {
        return {
          ...item,
          UOMR: item.changeAmt,
          total: item.changeAmt,
        };
      }
      if (item.drugActivityTypeCd === 'DBUP') {
        return {
          ...item,
          DBUP: item.changeAmt,
          total: item.changeAmt,
        };
      }
      return { ...item, total: item.changeAmt };
    });

    return updatedSearchResult;
  };

  const formattedData = (searchResult = []) => {
    let updatedSearchResult = searchResult;
    updatedSearchResult.sort((a, b) => {
      const splittedQtrA = a.targetQtr?.split('Q');
      const splittedQtrB = b.targetQtr?.split('Q');
      return (
        splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0]
      );
    });
    updatedSearchResult = getDataForTable(
      updatedSearchResult,
      'mfgName',
      mfgOrder
    );
    const restKeyAsObj = drugActivityTypeSelected.reduce((acc, el) => {
      acc[el] = 0;
      return acc;
    }, {});

    updatedSearchResult = updatedSearchResult.map((item) => {
      const modified = {
        ...restKeyAsObj,
        ...item,
      };

      const arrToLoop = [...drugActivityTypeSelected, 'total'];
      for (let i = 0; i < arrToLoop.length; i += 1) {
        if (modified[arrToLoop[i]] !== 0) {
          modified[arrToLoop[i]] = parseFloat(
            modified[arrToLoop[i]].toFixed(2)
          );
        }
      }
      return modified;
    });
    return updatedSearchResult;
  };
  React.useEffect(() => {
    const updatedSearchResult = formattedData(searchResult);
    setResultList(updatedSearchResult);
    const Totalcount = updatedSearchResult.filter(
      (row) => row.targetQtr !== "Total"
    ).length
    setTableCount(Totalcount)
  }, [searchResult, mfgOrder]);

  React.useEffect(() => {
    if (
      exportAllClicked &&
      Object.keys(exportAllData).length === adjustmentSelected.length &&
      adjustmentSelected.length > 0
    ) {
      const datForExportAll = {};
      for (const key in exportAllData) {
        const formattedDataOfoneGroup = JSON.parse(
          JSON.stringify(exportAllData[key])
        );
        datForExportAll[key] = formattedData(formattedDataOfoneGroup);
      }
      setExportAllClicked(false);
      if (Object.values(datForExportAll)[0].length > 0) {
        exportAllPDF(
          datForExportAll,
          userDefaults,
          {
            adjustmentSelected,
            info: {
              fourthInfo: `${rebateProgrameName}`,
              firstInfo: `Date Range : ${`${fromDate} - ${toDate}`}`,
            },
            pageSize: {
              height: 800,
              width: 1000,
            },
            reportName: 'Adjustment by Reason Code Report',
            fileName: exportFileName
              ? exportFileName
              : 'AdjustmentByReasoncode',
          },
          dispatch,
          logInUser,
          columnApi
        );
      } else {
        setError([NO_DATA]);
      }
    }
  }, [exportAllData]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    // const displayedRows = resultList;
    const displayedRows = filterApply ? filteredRows : resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      if (object.targetQtr === 'Total') return accumulator;
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : 0)
      );
    }, 0);
    return data || '0.00';
  };

  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        URAC: sum('URAC'),
        URCA: sum('URCA'),
        URAL: sum('URAL'),
        WOFF: sum('WOFF'),
        DBAL: sum('DBAL'),
        FRGV: sum('FRGV'),
        IOAR: sum('IOAR'),
        IDBL: sum('IDBL'),
        ICLC: sum('ICLC'),
        IDBU: sum('IDBU'),
        UACD: sum('UACD'),
        UACM: sum('UACM'),
        UAAR: sum('UAAR'),
        UCCN: sum('UCCN'),
        UOCR: sum('UOCR'),
        UOMR: sum('UOMR'),
        DBUP: sum('DBUP'),
        total: sum('total'),

        mfgName: 'Total',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [resultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const onSortChanged = (params) => {
    const colState = params.columnApi.getColumnState();
    const changedCol = colState.find((col) => col.sort !== null);
    if (changedCol?.colId === 'mfgName' && changedCol.sort !== mfgOrder) {
      setMfgOrder(changedCol.sort);
    }
  };

  // PDF Header
  const firstInfo = `Adjustment type: ${
    adjustmentSelected[count - 1]?.codeValue
  } - ${adjustmentSelected[count - 1]?.longDescription}`;
  const secondInfo = `Date Range: ${fromDate} - ${toDate}`; // For quarter dateRange.fromDate
  const thirdInfo = `${rebateProgrameName}`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Adjustment By Reason Code"
      />
      {/* <Spinner load={isLoading} /> */}
      <DisplayErrorMessages errorMessages={error.map((l) => l)} />
      {!fullScreenView && (
        <>
          <div className="row mb-5">
            <div className="col-12">
              <PaginationBox
                array={paginationArray}
                count={count}
                handleClick={handleClick}
                handleBlur={handleBlur}
              />
            </div>
          </div>
          <div className="tab-body custom-search-dates">
            <div className="mui-custom-form input-md field-xl">
              <div className="row mb-2">
                <div className="col-6">
                  <TextField
                    label="Rebate Program : "
                    id="rebateProgram"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={rebateProgrameName}
                    name="RebateProgram"
                    disabled
                  />
                </div>
                <div className="col-6">
                  <TextField
                    label="Date Range :"
                    id="dateRange"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={`${fromDate} - ${toDate}`}
                    name="dateRange"
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <TextField
                    label="Adjustment Type : "
                    id="adjustmentType"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={`${adjustmentSelected[count - 1]?.codeValue} - ${
                      adjustmentSelected[count - 1]?.longDescription
                    }`}
                    name="adjustmentType"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* Should have unique column for each reason code */}

      <TableGrid
        columnDefs={getRequiredColumn(adjustmentSelected[count - 1]?.codeValue)}
        rowData={resultList.map((item) => {
          // if (item < 0) {
          return {
            ...item,
            URAC: item.URAC ? item.URAC : '0.00',
            URCA: item.URCA ? item.URCA : '0.00',
            URAL: item.URAL ? item.URAL : '0.00',
            WOFF: item.WOFF ? item.WOFF : '0.00',
            DBAL: item.DBAL ? item.DBAL : '0.00',
            FRGV: item.FRGV ? item.FRGV : '0.00',
            IOAR: item.IOAR ? item.IOAR : '0.00',
            IDBL: item.IDBL ? item.IDBL : '0.00',
            ICLC: item.ICLC ? item.ICLC : '0.00',
            IDBU: item.IDBU ? item.IDBU : '0.00',

            UACD: item.UACD ? item.UACD : '0.00',
            UACM: item.UACM ? item.UACM : '0.00',
            UAAR: item.UAAR ? item.UAAR : '0.00',
            UCCN: item.UCCN ? item.UCCN : '0.00',
            UOCR: item.UOCR ? item.UOCR : '0.00',
            UOMR: item.UOMR ? item.UOMR : '0.00',
            DBUP: item.DBUP ? item.DBUP : '0.00',
            total: item.total ? item.total : '0.00',
          };
          // }
        })}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        hideTotalCount={true}
        gridCall={onGridReady}
        exportFile
        reportName="Adjustment by Reason Code Report"
        fileName="AdjustmentByReasoncode"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        onSortChanged={onSortChanged}
        gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
        info={{ firstInfo, secondInfo, thirdInfo }}
        pinnedBottomRowData={pinnedBottomRowData}
        exportAllTpPDF={adjustmentSelected.length > 1 ? exportAllTpPDF : null}
        isScrollOn
        noGlobalSort
        countValue={count}
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 25) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
        onFilterData={onFilterChanged}
        getFilterApply={getFilterApply}
      />
       <p className="total-results" tabIndex="0">
        Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
        </p>
    </div>
  );
}
